module.exports = __webpack_public_path__ + "img/1377098897.51f0df49.jpg";